module.exports = __webpack_public_path__ + "static/media/音乐播放器.a772b5dd.png";